import { NgModule } from '@angular/core';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { MaterialModule } from '../material-module';
import { NgxMaskModule } from 'ngx-mask';
import { IndicateComponent } from './components/indicate/indicate.component';
import { LoadingComponent } from './components/loading/loading.component';
import { MyProfileComponent } from './components/myprofile/myprofile.component';
import { TermsComponent } from './components/terms/terms.component';
import { TitleComponent } from './components/title/title.component';
import { InputDropdownComponent } from './components/input-dropdown/input-dropdown.component';
import { SharedModule } from './shared.module';
import { FileUploadComponent } from '../core/components/fileUpload/fileUpload.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AddressComponent } from './components/address/address.component';
import { MapComponent } from './components/mapbox/map.component';
import { CardComponent } from '../modules/realtor/components/cards/card.component';
import { AdComponent } from '../modules/realtor/components/cards/ad.component';
import { PersonCardComponent } from '../modules/realtor/components/cards/person-card/person-card.component';
import { AdCardComponent } from '../modules/realtor/components/cards/ad-card/ad-card.component';
import { ComplementFollowComponent } from '../modules/realtor/components/complement/follow/follow.component';
import { AdvertiseFormComponent } from '../modules/home/components/advertise/advertise.form.component';
import { ViewComponent } from '../modules/realtor/components/view/view.component';
import { AdvertiseComponent } from '../modules/realtor/components/view/advertise/advertise.component';
import { ComplementAddressComponent } from '../modules/realtor/components/complement/address/address.component';
import { ComplementPhoneComponent } from '../modules/realtor/components/complement/phone/phone.component';
import { ViewContentComponent } from '../modules/realtor/components/view/view-content.component';
import { AdBuildingComponent } from '../modules/realtor/components/view/ad-building/ad-building.component';
import { AdGroundComponent } from '../modules/realtor/components/view/ad-ground/ad-ground.component';
import { AdVehiclesComponent } from '../modules/realtor/components/view/ad-vehicles/ad-vehicles.component';
import { AdPropertiesComponent } from '../modules/realtor/components/view/ad-properties/ad-properties.component';
import { UnitMapComponent } from '../modules/realtor/components/view/components/unit-map/unit-map.component';
import { ConditionsComponent } from '../modules/realtor/components/view/components/conditions/conditions.component';
import { HeaderComponent } from '../modules/realtor/components/view/components/header/header.component';
import { OwnerComponent } from '../modules/realtor/components/view/components/owner/owner.component';
import { ComissionComponent } from '../modules/realtor/components/view/components/comission/comission.component';
import { PromotionsComponent } from '../modules/realtor/components/view/components/promotions/promotions.component';
import { ProposalComponent } from '../modules/realtor/components/view/components/proposal/proposal.component';
import { FilesComponent } from '../modules/realtor/components/view/components/files/files.component';
import { SimilarComponent } from '../modules/realtor/components/view/components/similar/similar.component';
import { LocationComponent } from '../modules/realtor/components/view/components/location/location.component';
import { PaymentComponent } from '../modules/realtor/components/view/components/payment/payment.component';
import { GeneralComponent } from '../modules/realtor/components/view/components/general/general.component';
import { UnitDetailComponent } from '../modules/realtor/components/view/components/unit-detail/unit-detail.component';
import { RecreationAreaComponent } from '../modules/realtor/components/view/components/recreationarea/recreationarea.component';
import { PlantsComponent } from '../modules/realtor/components/view/components/plants/plants.component';
import { DeliveryComponent } from '../modules/realtor/components/view/components/delivery/delivery.component';
import { UnitsComponent } from '../modules/realtor/components/view/components/units/units.component';
import { GalleryShareComponent } from '../modules/realtor/components/view/components/gallery-share/gallery-share.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AvailableComponent } from '../modules/builder/components/available/available.component';
import { SharesComponent } from '../modules/builder/components/shares/shares.component';

import { FollowersComponent } from '../modules/builder/components/followers/followers.component';
import { ActivitiesComponent } from '../modules/builder/components/activities/activities.component';
import { ModalComponent } from './components/modal/modal.component';
import { DialogActionComponent } from './components/dialog-action/dialog-action.component';
import { MsgLoadingComponent } from './components/msgLoading/msgLoading.component';
import { AccessManagerComponent } from '../modules/admin/components/person/accessManager/accessManager.component';
import { HeatmapComponent } from './components/heatmap/heatmap.component';
import { IconsComponent } from './components/icons/icons.component';
import { PipeSafeHtml } from '../core/pipe/pipe-safeHtml';
import { TypeofPipe } from '../core/pipe/pipe-typeof';
import { ShareLinkComponent } from '../modules/realtor/components/view/components/shareLink/shareLink.component';
import { UnitAmountComponent } from '../modules/builder/components/unit-amount/unit-amount.component';
import { DeepLinkComponent } from './components/deeplink/deeplink.component';
import { NguiInViewComponent } from './components/ngui-in-view/ngui-in-view.component';
import { NguiInViewDirective } from './components/ngui-in-view/ngui-in-view.directive';

import { CompleteSignupComponent } from '../modules/realtor/components/complete-signup/complete-signup.component';
import { UsersManagerComponent } from './components/usersManager/usersManager.component';
import { SafePipe } from '../core/pipe/pipe-safe';
import { LearningComponent } from '../modules/realtor/components/view/components/learning/learning.component';
import { ProgressComponent } from '../modules/realtor/components/view/components/progress/progress.component';
import { TourComponent } from '../modules/realtor/components/view/components/tour/tour.component';
import { RealestateComponent } from './components/realestate/realestate.component';
import { FeedbackComponent } from './components/feedback/feedback.component';
import { ProfileComponent } from './components/profile/profile.component';
import { RequestItemComponent } from './components/request-item/request-item.component';
import { DialogAuthorizationComponent } from './components/dialog-authorization/dialog-authorization.component';
import { AuthorizationPreviewComponent } from './components/authorization-preview/authorization-preview.component';
import { ReasonComponent } from './components/reason/reason.component';
import { SignaturePadComponent } from './components/signature-pad/signature-pad.component';
import { SignatureComponent } from './components/signature/signature.component';
import { DialogRestrictedAccessComponent } from './components/dialog-restricted-access/dialog-restricted-access.component';
import { DialogMaterialComponent } from './components/dialog-material/dialog-material.component';
import { ExpensesComponent } from './components/expenses/expenses.component';
import { ReportComponent } from './components/report/report.component';
import { DialogPreferencesComponent } from './components/dialog-preferences/dialog-preferences.component';
import { DialogAuthorizationListComponent } from './components/dialog-authorization-list/dialog-authorization-list.component';
import { DialogRequestListComponent } from './components/dialog-request-list/dialog-request-list.component';
import { CanvaComponent } from './components/canva-component/canva.component';
import { RequestsComponent } from './components/requests/requests.component';
import { LeadsComponent } from './components/leads/leads.component';
import { SiteComponent } from './components/site/site.component';
import { AceEditorModule } from 'ng2-ace-editor';
import { PostsComponent } from './components/posts/posts.component';
import { GalleryComponent } from './components/gallery/gallery.component';


const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  direction: 'horizontal',
  slidesPerView: 'auto'
};


@NgModule({
  declarations: [
    LoadingComponent,
    MyProfileComponent,
    DialogPreferencesComponent,
    DialogAuthorizationListComponent,
    DialogRequestListComponent,
    ProfileComponent,
    DeepLinkComponent,
    TermsComponent,
    TitleComponent,
    InputDropdownComponent,
    IndicateComponent,
    RealestateComponent,
    FeedbackComponent,
    FileUploadComponent,
    AddressComponent,
    MapComponent,
    CardComponent,
    AdComponent,
    PersonCardComponent,
    AdCardComponent,
    ComplementFollowComponent,
    AdvertiseFormComponent,
    AdvertiseComponent,
    ViewComponent,
    ComplementAddressComponent,
    ComplementPhoneComponent,
    ViewContentComponent,
    AdBuildingComponent,
    AdGroundComponent,
    AdVehiclesComponent,
    AdPropertiesComponent,
    UnitMapComponent,
    ConditionsComponent,
    HeaderComponent,
    LearningComponent,
    TourComponent,
    ProgressComponent,
    OwnerComponent,
    ComissionComponent,
    PromotionsComponent,
    ProposalComponent,
    ShareLinkComponent,
    FilesComponent,
    SimilarComponent,
    LocationComponent,
    PaymentComponent,
    GeneralComponent,
    UnitDetailComponent,
    RecreationAreaComponent,
    PlantsComponent,
    DeliveryComponent,
    UnitsComponent,
    GalleryShareComponent,
    AvailableComponent,
    UnitAmountComponent,
    HeatmapComponent,

    SharesComponent,
    RequestsComponent,
    FollowersComponent,
    ActivitiesComponent,
    ModalComponent,
    DialogActionComponent,
    DialogAuthorizationComponent,
    DialogRestrictedAccessComponent,
    DialogMaterialComponent,
    AuthorizationPreviewComponent,
    MsgLoadingComponent,
    AccessManagerComponent,
    UsersManagerComponent,
    PostsComponent,
    GalleryComponent,
    IconsComponent,
    PipeSafeHtml,
    TypeofPipe,
    SafePipe,
    NguiInViewComponent,
    NguiInViewDirective,
    CompleteSignupComponent,
    RequestItemComponent,

    ReasonComponent,
    SignaturePadComponent,
    SignatureComponent,
    ExpensesComponent,
    ReportComponent,
    LeadsComponent,
    CanvaComponent,
    SiteComponent,
  ],
  imports: [
    DragDropModule,
    SharedModule,
    MaterialModule,
    SwiperModule,
    NgxMaskModule.forRoot({}),
    AceEditorModule
  ],
  exports: [
    DragDropModule,
    SharedModule,
    MaterialModule,
    SwiperModule,
    NgxMaskModule,
    LoadingComponent,
    ProfileComponent,
    MyProfileComponent,
    DialogPreferencesComponent,
    DialogAuthorizationListComponent,
    DialogRequestListComponent,
    DeepLinkComponent,
    TermsComponent,
    IndicateComponent,
    RealestateComponent,
    FeedbackComponent,
    TitleComponent,
    InputDropdownComponent,
    FileUploadComponent,
    AddressComponent,
    MapComponent,
    CardComponent,
    AdComponent,
    ShareLinkComponent,
    AdCardComponent,
    PersonCardComponent,
    ComplementFollowComponent,
    AdvertiseComponent,
    ComplementAddressComponent,
    ComplementPhoneComponent,
    PipeSafeHtml,
    SafePipe,
    TypeofPipe,
    IconsComponent,
    NguiInViewComponent,
    NguiInViewDirective,
    RequestItemComponent,
    CompleteSignupComponent,
    CanvaComponent
  ],
  entryComponents: [
    TermsComponent,
    IndicateComponent,
    RealestateComponent,
    FeedbackComponent,
    ProfileComponent,
    MyProfileComponent,
    DialogPreferencesComponent,
    DialogAuthorizationListComponent,
    DialogRequestListComponent,
    AdCardComponent,
    PersonCardComponent,
    ComplementFollowComponent,
    AdvertiseFormComponent,
    ViewComponent,
    AdvertiseComponent,

    ViewContentComponent,
    AdBuildingComponent,
    AdGroundComponent,
    AdVehiclesComponent,
    AdPropertiesComponent,
    UnitMapComponent,
    ConditionsComponent,
    HeaderComponent,
    LearningComponent,
    TourComponent,
    ProgressComponent,
    OwnerComponent,
    ComissionComponent,
    PromotionsComponent,
    ProposalComponent,
    ShareLinkComponent,
    FilesComponent,
    SimilarComponent,
    LocationComponent,
    PaymentComponent,
    GeneralComponent,
    UnitDetailComponent,
    RecreationAreaComponent,
    PlantsComponent,
    DeliveryComponent,
    UnitsComponent,
    GalleryShareComponent,
    AvailableComponent,
    UnitAmountComponent,
    HeatmapComponent,

    SharesComponent,
    RequestsComponent,
    FollowersComponent,
    ActivitiesComponent,
    ModalComponent,
    DialogActionComponent,
    DialogAuthorizationComponent,
    DialogRestrictedAccessComponent,
    DialogMaterialComponent,
    AuthorizationPreviewComponent,
    MsgLoadingComponent,
    AccessManagerComponent,
    UsersManagerComponent,
    PostsComponent,
    GalleryComponent,
    CompleteSignupComponent,

    ReasonComponent,
    SignaturePadComponent,
    SignatureComponent,
    ExpensesComponent,
    ReportComponent,
    LeadsComponent,
    CanvaComponent,
    SiteComponent,


  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ]
})
export class SharedWebModule {

}
